// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3Ra6S","icon":"style_icon__1ETqi","avatar":"style_avatar__12nh8","menuIcon":"style_menuIcon__2vY39"};